import React from "react";
import { Star, ListPlus, Check } from "lucide-react";
import { toast } from "sonner";
import { useFollow } from "@/features/follow/FollowContext";
import { useAnalysisList } from "@/features/analysis/AnalysisListContext";
import { AnalysisSelection } from "@/features/analysis/combinationAnalyzer";
import { resolveMarket } from "@/presentation/marketRegistry";
import { useI18n } from "@/i18n";

export function FollowButton({
  fixtureId, label, league, size = "md",
}: { fixtureId: string; label: string; league?: string | null; size?: "sm" | "md" }) {
  const { lang } = useI18n();
  const { isFollowing, toggleFollow } = useFollow();
  const active = isFollowing(fixtureId);
  const pad = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs";
  return (
    <button
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleFollow({ fixtureId, label, league });
        toast.success(active ? (lang === "tr" ? "Takipten çıkarıldı" : "Unfollowed") : (lang === "tr" ? "Maç takibe alındı" : "Following match")); }}
      data-testid={`follow-btn-${fixtureId}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition ${pad} ${
        active ? "border-gold/40 bg-gold/10 text-gold-300" : "border-white/10 bg-white/5 text-muted-foreground hover:text-foreground"
      }`}
    >
      <Star className={`h-3.5 w-3.5 ${active ? "fill-gold-300" : ""}`} />
      {active ? (lang === "tr" ? "Takipte" : "Following") : (lang === "tr" ? "Takip et" : "Follow")}
    </button>
  );
}

export function AddToSlipButton({
  selection, size = "md",
}: { selection: Omit<AnalysisSelection, "addedAt">; size?: "sm" | "md" }) {
  const { lang } = useI18n();
  const { has, add, remove } = useAnalysisList();
  const active = has(selection.fixtureId, selection.marketCode);
  const pad = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs";
  return (
    <button
      onClick={(e) => {
        e.preventDefault(); e.stopPropagation();
        if (active) { remove(selection.fixtureId, selection.marketCode); toast.message(lang === "tr" ? "Listeden çıkarıldı" : "Removed from list"); }
        else { add(selection); toast.success((lang === "tr" ? "Analiz Listem'e eklendi: " : "Added to list: ") + resolveMarket(selection.marketCode, lang, selection.marketName).label); }
      }}
      data-testid={`add-slip-${selection.fixtureId}-${selection.marketCode}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition ${pad} ${
        active ? "border-atlas/40 bg-atlas/12 text-atlas-300" : "border-white/10 bg-white/5 text-muted-foreground hover:text-foreground"
      }`}
    >
      {active ? <Check className="h-3.5 w-3.5" /> : <ListPlus className="h-3.5 w-3.5" />}
      {active ? (lang === "tr" ? "Eklendi" : "Added") : (lang === "tr" ? "Listeye ekle" : "Add to list")}
    </button>
  );
}
